import { useEffect, useRef, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import { colors } from '@src/styles';
import { card, titleFontFamily } from '../utils/format';
import { OrganizationPicker } from './OrganizationPicker';
import { useRunsContext } from '../context/RunsContext';

const EXIT_DURATION_MS = 220;

export function SelectOrganizationState() {
  const { setOrganizationId } = useRunsContext();
  const [isLeaving, setIsLeaving] = useState(false);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const handleSelect = (organizationId: string) => {
    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      setOrganizationId(organizationId);
      return;
    }
    setIsLeaving(true);
    timerRef.current = window.setTimeout(() => setOrganizationId(organizationId), EXIT_DURATION_MS);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: { xs: 2, md: 8 } }}>
      <Paper
        elevation={0}
        sx={{
          ...card,
          width: '100%',
          maxWidth: 520,
          padding: { xs: 2.5, md: 3.5 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          textAlign: 'center',
          opacity: isLeaving ? 0 : 1,
          transform: isLeaving ? 'translateY(-10px) scale(0.98)' : 'none',
          transition: `opacity ${EXIT_DURATION_MS}ms ease, transform ${EXIT_DURATION_MS}ms ease`,
          pointerEvents: isLeaving ? 'none' : 'auto',
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 160, 21, 0.12)',
          }}
        >
          <ApartmentRoundedIcon sx={{ fontSize: 24, color: `${colors.primary.yellow} !important` }} />
        </Box>
        <Typography
          component="h2"
          sx={{ fontFamily: titleFontFamily, fontSize: '18px', fontWeight: 600, color: colors.primary.white }}
        >
          Escolha uma organização
        </Typography>
        <Typography sx={{ fontSize: '13.5px', lineHeight: 1.55, color: colors.brand.textSecondary, maxWidth: 400 }}>
          As execuções são carregadas por organização. Selecione uma para ver os indicadores, as automações e os logs do
          período.
        </Typography>
        <Box sx={{ width: '100%', marginTop: 1 }}>
          <OrganizationPicker size="large" autoFocus onSelect={handleSelect} />
        </Box>
      </Paper>
    </Box>
  );
}
